import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Corporatecabserviceinmumbai() {



const cardData = {
  keyword: " Corporate Cab Services in Mumbai",

headingDescription:
  "Omshree Cab offers professional and dependable corporate cab services in Mumbai designed to meet the transportation needs of businesses, executives, and employees. Whether your company requires daily employee pickup and drop, airport transfers for business travelers, transportation for meetings and conferences, or outstation corporate travel, our cab service ensures reliable and comfortable mobility across the city. We provide flexible corporate travel solutions including dedicated fleet services, hourly rentals, and customized monthly packages at transparent pricing. Our fleet includes well-maintained air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for executives, teams, and corporate groups. With experienced chauffeurs familiar with Mumbai’s business districts, punctual service, and 24/7 customer support, Omshree Cab is a trusted partner for corporate transportation in Mumbai.",

topPlaces: [
  {
    title: "Nariman Point",
    description:
      "Nariman Point is one of the most important business districts in Mumbai and is home to several corporate headquarters, financial institutions, and commercial offices. Located at the southern end of Marine Drive, the area features impressive office towers, luxury hotels, and conference venues that host business meetings and corporate events. Many executives and business travelers visit Nariman Point for corporate meetings and networking opportunities. Reliable corporate cab services ensure professionals can travel comfortably between offices, hotels, and airports while maintaining punctual schedules. The area also offers beautiful views of the Arabian Sea and remains one of the most prestigious commercial hubs in the city." 
  },
  {
    title: "Bandra Kurla Complex",
    description:
      "Bandra Kurla Complex, commonly known as BKC, is one of Mumbai’s most modern and rapidly growing financial and commercial districts. The area hosts major corporate offices, multinational companies, banks, and business centers, making it a hub for corporate activity. Large conferences, corporate events, and international business meetings frequently take place here. Due to the high volume of professionals commuting daily, corporate cab services play an important role in providing efficient and comfortable transportation for employees and executives traveling to meetings or office campuses across the city."
  },
  {
    title: "Lower Parel",
    description:
      "Lower Parel has transformed from an industrial area into a modern corporate and commercial hub filled with office towers, coworking spaces, and business parks. Many large companies and startups operate from this area, attracting professionals from across Mumbai. The district also features upscale restaurants, hotels, and event venues used for corporate meetings and networking events. Corporate cab services help employees and business travelers commute smoothly to and from offices, especially during peak traffic hours."
  },
  {
    title: "Powai Business District",
    description:
      "Powai is a major IT and corporate hub in Mumbai and is home to many multinational companies, technology firms, and corporate campuses. The area around Powai Lake features modern office buildings, luxury hotels, and residential complexes for professionals working in the technology and corporate sectors. Business travelers frequently visit Powai for meetings, training sessions, and conferences. Corporate cab services provide comfortable transportation for employees and executives traveling between offices, hotels, and airports."
  },
  {
    title: "Andheri East",
    description:
      "Andheri East is one of the busiest commercial areas in Mumbai and a major location for corporate offices, IT companies, and business centers. Its proximity to the international airport makes it a preferred destination for business travelers arriving in the city. Many companies operate from corporate parks and commercial complexes in this area. Reliable corporate cab services help employees reach offices on time and provide efficient airport transfers for executives and visiting clients."
  },
  {
    title: "Fort Business District",
    description:
      "The Fort area in South Mumbai is one of the city’s oldest commercial districts and remains a significant center for banking, finance, and corporate offices. The area includes historic buildings, commercial streets, and major office complexes where many businesses operate. Important roads such as Dadabhai Naoroji Road connect several commercial establishments and heritage structures in the district. Corporate cab services are commonly used by professionals traveling to meetings, offices, and government institutions located in this historic business hub."
  },
  {
    title: "BKC Convention Centers",
    description:
      "BKC also hosts some of Mumbai’s largest convention centers and event venues where corporate conferences, exhibitions, and business summits are held. Professionals from across India and abroad attend events in this area throughout the year. Corporate cab services ensure smooth transportation for delegates, executives, and employees attending business events, helping companies manage large-scale travel arrangements efficiently."
  },
  {
    title: "Mumbai International Airport",
    description:
      "Mumbai International Airport is one of the busiest airports in India and serves as a major gateway for business travelers visiting the financial capital of the country. Corporate executives, international clients, and employees frequently travel through the airport for meetings, conferences, and business projects. Corporate cab services provide timely airport pickup and drop facilities, ensuring comfortable and punctual transfers for professionals arriving in or departing from Mumbai."
  },
  {
    title: "Worli Business District",
    description:
      "Worli is another important commercial area in Mumbai known for its modern office buildings, luxury hotels, and business centers. The district connects easily to other major business hubs such as Lower Parel, Bandra, and Nariman Point through major roads and the Bandra Worli Sea Link. Corporate meetings, conferences, and networking events often take place in this area. Corporate cab services help professionals travel efficiently between different business locations across the city."
  },
  {
    title: "Colaba Business Area",
    description:
      "Colaba is a prominent area in South Mumbai that combines tourism, business, and hospitality. The district features corporate offices, luxury hotels, restaurants, and cultural attractions. Many international business travelers stay in Colaba while attending meetings in nearby business districts such as Nariman Point and Fort. Corporate cab services provide convenient transportation for executives traveling between hotels, offices, conference venues, and other business destinations across Mumbai."
  }
],



services: [
{
name: "Corporate Cab Service Mumbai",
description: "Corporate cab service in Mumbai provides reliable transportation solutions for companies and business professionals across the city. Our fleet includes comfortable AC sedans, SUVs, and executive vehicles suitable for office travel and corporate meetings. Professional drivers ensure punctual pickup and safe driving throughout the journey. Pickup services are available from offices, hotels, homes, and airport terminals across Mumbai. Ideal for daily office travel, employee transport, and client meetings. Spacious interiors ensure comfortable travel for executives and staff. Flexible booking options allow scheduled corporate rides. Reliable cab services ensure smooth and professional business transportation."
},
{
name: "Corporate Taxi Service Mumbai",
description: "Corporate taxi service in Mumbai offers dependable travel solutions for business professionals and corporate organizations. Our fleet of AC taxis ensures comfortable travel across city routes and highways. Professional drivers ensure punctual pickup and courteous service for business travelers. Pickup services are available from offices, hotels, homes, and airports across Mumbai. Ideal for meetings, corporate events, and executive travel. Spacious interiors ensure relaxed travel for passengers. Flexible booking options allow companies to manage travel schedules easily. Reliable taxi services ensure efficient corporate transportation."
},
{
name: "Company Cab Service Mumbai",
description: "Company cab service in Mumbai provides organized transportation solutions for corporate offices and employees. Our fleet includes comfortable sedans and SUVs suitable for daily office travel. Professional drivers ensure punctual pickup and safe driving for employees and business executives. Pickup services are available from residential areas, offices, and transport hubs across Mumbai. Ideal for daily office commute and business travel. Spacious seating ensures comfortable journeys for passengers. Flexible scheduling allows companies to arrange regular transport services. Reliable company cab services ensure efficient staff mobility."
},
{
name: "Employee Transport Service Mumbai",
description: "Employee transport service in Mumbai offers reliable commuting solutions for companies managing staff travel. Our fleet includes AC vehicles designed for safe and comfortable employee transportation. Professional drivers ensure punctual pickup and drop services for office staff. Pickup services are available from homes and office locations across Mumbai. Ideal for IT companies, corporate offices, and business organizations. Spacious interiors ensure comfortable travel for employees. Flexible scheduling supports shift-based office travel. Reliable employee transport services ensure smooth daily commuting."
},
{
name: "Office Pickup Drop Cab Mumbai",
description: "Office pickup drop cab service in Mumbai provides convenient transportation for employees traveling between home and workplace. Our fleet includes comfortable AC sedans and SUVs suitable for daily commuting. Professional drivers ensure safe driving and punctual pickup and drop services. Pickup services are available across residential areas and office zones in Mumbai. Ideal for corporate staff and company executives. Spacious seating ensures comfortable journeys during office travel. Flexible scheduling supports morning and evening office shifts. Reliable cab services ensure smooth office transportation."
},
{
name: "Corporate Car Rental Mumbai",
description: "Corporate car rental in Mumbai offers professional transportation solutions for business meetings and executive travel. Our fleet includes premium sedans and SUVs designed for comfortable corporate travel. Professional chauffeurs ensure punctual pickup and smooth driving services. Pickup services are available from offices, hotels, homes, and airports across Mumbai. Ideal for corporate events, client meetings, and business travel. Spacious interiors ensure comfortable journeys for executives. Flexible rental packages allow hourly, daily, or monthly bookings. Reliable corporate car rental ensures professional transportation."
},
{
name: "Staff Transport Service Mumbai",
description: "Staff transport service in Mumbai provides organized transportation for companies managing employee commuting needs. Our fleet includes comfortable AC vehicles suitable for group employee travel. Professional drivers ensure safe driving and punctual pickup services for staff members. Pickup services are available from residential areas and office locations across Mumbai. Ideal for corporate offices, IT companies, and industrial staff transport. Spacious seating ensures comfortable journeys for employees. Flexible scheduling supports multiple office shifts. Reliable staff transport services ensure smooth workforce mobility."
},
{
name: "Monthly Corporate Cab Service Mumbai",
description: "Monthly corporate cab service in Mumbai offers long-term transportation solutions for companies requiring regular employee travel. Our fleet includes comfortable AC sedans and SUVs suitable for daily commuting. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across residential areas and office locations in Mumbai. Ideal for companies managing daily staff transportation. Spacious seating ensures comfortable journeys for employees. Flexible monthly packages allow companies to manage transport budgets efficiently. Reliable cab services ensure consistent corporate travel support."
},
{
name: "Corporate Airport Transfer Mumbai",
description: "Corporate airport transfer service in Mumbai offers reliable transportation for business travelers arriving or departing from Mumbai Airport. Our fleet includes executive sedans and premium SUVs designed for comfortable airport transfers. Professional chauffeurs monitor flight schedules to ensure punctual pickup and drop services. Pickup is available from Terminal 1 and Terminal 2 of Mumbai Airport. Ideal for corporate executives, business guests, and client travel. Spacious interiors ensure comfortable journeys. Flexible booking options allow advance reservations. Reliable airport transfer services ensure smooth corporate travel."
},
{
name: "Corporate Travel Taxi Mumbai",
description: "Corporate travel taxi service in Mumbai provides dependable transportation for business professionals attending meetings and corporate events. Our fleet includes AC sedans and SUVs suitable for executive travel across the city. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from offices, hotels, homes, and airport terminals across Mumbai. Ideal for business trips, client meetings, and corporate tours. Spacious seating ensures comfortable journeys for passengers. Flexible travel scheduling supports business travel plans. Reliable taxi services ensure professional transportation."
},
{
name: "Executive Cab Service Mumbai",
description: "Executive cab service in Mumbai offers premium transportation for corporate executives and VIP business travelers. Our fleet includes luxury sedans and premium SUVs designed for high-end travel comfort. Professional chauffeurs ensure smooth driving and punctual pickup services. Pickup services are available across Mumbai including offices, hotels, and airports. Ideal for corporate meetings, airport transfers, and executive travel. Spacious interiors ensure superior comfort during journeys. Flexible booking options allow convenient ride scheduling. Reliable executive cab services ensure a professional travel experience."
}
],

tableData: [
["Corporate Cab Service Mumbai","Corporate Taxi Service Mumbai"],
["Company Cab Service Mumbai","Employee Transport Service Mumbai"],
["Office Pickup Drop Cab Mumbai","Corporate Car Rental Mumbai"],
["Staff Transport Service Mumbai","Monthly Corporate Cab Service Mumbai"],
["Corporate Airport Transfer Mumbai","Corporate Travel Taxi Mumbai"],
["Executive Cab Service Mumbai","Business Cab Service Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Professional Corporate Drivers",
    WhyChoosedescription: "Our drivers are trained to provide professional corporate transportation in Mumbai. They understand punctuality, professional conduct, and efficient routes to ensure smooth business travel for employees and executives."
  },
  {
    WhyChooseheading: "Transparent Corporate Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for corporate cab services in Mumbai. We clearly explain travel packages, hourly bookings, and per-kilometer charges so companies can manage their transportation budgets effectively."
  },
  {
    WhyChooseheading: "24/7 Corporate Travel Support",
    WhyChoosedescription: "Corporate travel often requires flexible timing. Our cab service operates 24/7, ensuring employees and executives can travel safely for meetings, airport transfers, and late-night shifts."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized. This ensures comfortable and professional travel for corporate clients."
  },
  {
    WhyChooseheading: "Flexible Corporate Travel Plans",
    WhyChoosedescription: "We offer flexible corporate travel packages including employee transportation, airport transfers, business meeting travel, and long-term corporate cab contracts."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for executives, teams, and corporate groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from offices, hotels, business centers, railway stations, and airports anywhere in Mumbai for seamless corporate transportation."
  },
  {
    WhyChooseheading: "Reliable Business Transportation",
    WhyChoosedescription: "Omshree Cabs is trusted by many companies for reliable corporate cab services in Mumbai. Our punctual drivers, comfortable vehicles, and professional service ensure stress-free business travel."
  }
]
};

const faqData = [
  { question: "Do you provide corporate cab services in Mumbai?", answer: "Yes, Omshree Cabs provides dedicated corporate cab services for companies in Mumbai including employee transportation and executive travel." },
  { question: "Can companies book long-term corporate transportation?", answer: "Yes, we offer long-term corporate cab contracts for regular employee transportation and business travel." },
  { question: "Do you provide airport transfers for corporate clients?", answer: "Yes, we provide airport pickup and drop services for executives and corporate employees traveling via Mumbai Airport." },
  { question: "Which vehicles are available for corporate travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for business executives and corporate teams." },
  { question: "Is corporate cab service available 24 hours?", answer: "Yes, our corporate transportation service operates 24/7 to support different work shifts and business travel needs." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable corporate travel." },
  { question: "Do you provide transportation for business meetings and events?", answer: "Yes, we provide transportation for corporate meetings, conferences, events, and business travel." },
  { question: "Is advance booking required for corporate services?", answer: "Yes, advance booking is recommended especially for regular employee transportation services." },
  { question: "Do you provide multiple cars for corporate groups?", answer: "Yes, we can arrange multiple vehicles for corporate groups, employee transport, and business delegations." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Mehta",
    feedback:
      "Our company regularly uses Omshree Cabs for corporate travel in Mumbai. The service is punctual and professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Shah",
    feedback:
      "Excellent corporate cab service in Mumbai. Clean vehicles, polite drivers, and reliable transportation for our business meetings.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Mumbai",
  "description": "Omshree Cab provides professional Corporate Cab Services in Mumbai for employee transport, office pickups, monthly corporate cab plans, and airport transfers. Reliable and executive taxi service for companies with easy online booking and affordable fares.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2300"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Corporate Cab Services in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers corporate cab services in Mumbai for employee transport, office pickups, monthly plans, and airport transfers. Reliable and executive taxi service with easy online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinmumbai;